// extracted by mini-css-extract-plugin
module.exports = {"DrawletPanning":"pointer-events-bridge_DrawletPanning__3KPZT","DrawletPanningActive":"pointer-events-bridge_DrawletPanningActive__1hIgQ"};